import { client } from "api";
import { Checklist } from "models/Checklist";

export type GetChecklistRequest = string;

export type GetChecklistResponse = Checklist;

export const getChecklist = (id: GetChecklistRequest) =>
  client.get<GetChecklistResponse>(`/checklist/${id}`).then((res) => res.data);
